var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11.0001H9.00417C8.11327 11.0001 7.6671 9.92292 8.29707 9.29295L15.2929 2.29717C15.6834 1.90664 16.3165 1.90664 16.7071 2.29717L23.7029 9.29295C24.3328 9.92292 23.8867 11.0001 22.9957 11.0001H19V21.0001H22.9976C23.8882 21.0001 24.3345 22.0767 23.705 22.7068L16.7074 29.7118C16.3168 30.1028 15.6831 30.1028 15.2925 29.7118L8.29489 22.7068C7.66544 22.0767 8.11172 21.0001 9.00237 21.0001H13V11.0001Z",
    fill: "#12131A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 23.0001H11.4148L16 27.5901L20.5851 23.0001H17V9.00006H20.5815L16 4.41849L11.4184 9.00006H15V23.0001ZM22.9976 21.0001C23.8882 21.0001 24.3345 22.0767 23.705 22.7068L16.7074 29.7118C16.3168 30.1028 15.6831 30.1028 15.2925 29.7118L8.29489 22.7068C7.66544 22.0767 8.11172 21.0001 9.00237 21.0001H13V11.0001H9.00417C8.11327 11.0001 7.6671 9.92292 8.29707 9.29295L15.2929 2.29717C15.6834 1.90664 16.3165 1.90664 16.7071 2.29717L23.7029 9.29295C24.3328 9.92292 23.8867 11.0001 22.9957 11.0001H19V21.0001H22.9976Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_181",
    x: 5.00037,
    y: 0.504272,
    width: 21.9991,
    height: 34.0009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_181",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorVertical);
export default __webpack_public_path__ + "static/media/cursor-vertical.df61af3522407489e7ad111b8ddb32d1.svg";
export { ForwardRef as ReactComponent };